var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D2DF",
    fillRule: "nonzero",
    d: "M96 1.882v60.236c0 1.04-.895 1.882-2 1.882H2c-1.105 0-2-.843-2-1.882V1.882C0 .842.895 0 2 0h92c1.105 0 2 .843 2 1.882zm-7.084 58.353H92V3.765H4v56.47h1.98l22.505-24.57c.798-.871 2.232-.871 3.03 0l9.037 9.866 15.933-17.395c.798-.871 2.232-.871 3.03 0l29.401 32.1zm-61.832 0l10.827-11.82-7.926-8.654-18.734 20.474h15.833zm56.551 0l-25.65-28.003-25.623 28.003h51.273zM18.782 26.353c-4.15 0-7.513-3.371-7.513-7.53 0-4.158 3.364-7.529 7.513-7.529 4.15 0 7.513 3.371 7.513 7.53 0 4.158-3.364 7.529-7.513 7.529zm0-3.765a3.76 3.76 0 0 0 3.756-3.764 3.76 3.76 0 0 0-3.756-3.765 3.76 3.76 0 0 0-3.756 3.765 3.76 3.76 0 0 0 3.756 3.764z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.6799008b22866a235747057538478bb3.svg";
export { ForwardRef as ReactComponent };